import React from 'react';

/**
 * Enlaza los nombres de los productos propios allí donde aparecen en el texto,
 * dejando el resto intacto. Devuelve nodos React: se usa en JSX como
 * {linkifyProductos(texto)}.
 *
 * Nació solo para Kairos. Al aparecer el segundo producto se generalizó en vez
 * de duplicar la función: con dos copias, la tercera vez que se toque una se
 * olvidará la otra.
 *
 * Dos precauciones:
 *
 *  - La frase larga va antes que la corta en la alternancia, para que
 *    "Kairos Governance" gane sobre "Kairos" a secas.
 *  - Un lookahead impide enlazar el nombre cuando forma parte del dominio
 *    escrito en el propio texto: en "Teselia (teselia.es)" se enlaza la primera
 *    y se deja el literal en paz.
 */
type Producto = { patron: string; comprueba: RegExp; url: string };

const PRODUCTOS: Producto[] = [
  {
    // La frase completa primero, y luego el nombre suelto.
    patron: '\\bKairos Governance\\b|\\bKairos\\b(?!\\.)',
    comprueba: /^Kairos( Governance)?$/i,
    url: 'https://kairosgovernance.com',
  },
  {
    patron: '\\bTeselia\\b(?!\\.)',
    comprueba: /^Teselia$/i,
    url: 'https://teselia.es',
  },
];

const SPLIT = new RegExp(`(${PRODUCTOS.map((p) => p.patron).join('|')})`, 'gi');
const HAY_ALGUNO = /\b(Kairos|Teselia)\b/i;

export function linkifyProductos(text: string): React.ReactNode {
  if (!text || !HAY_ALGUNO.test(text)) return text;

  return text.split(SPLIT).map((part, i) => {
    const p = PRODUCTOS.find((x) => x.comprueba.test(part));
    if (!p) return part;
    return (
      <a
        key={i}
        href={p.url}
        target="_blank"
        rel="noopener noreferrer"
        className="kairos-link"
        onClick={(e) => e.stopPropagation()}
      >
        {part}
      </a>
    );
  });
}

/** Nombre anterior, cuando solo había un producto. */
export const linkifyKairos = linkifyProductos;
